import React, { useState, useEffect } from "react";
import { getDocument } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const SingleView: React.FC<{ docId: string | null }> = ({ docId }) => {
  const [file, setFile] = useState<{ fileData: string; mimeType: string; fileName: string } | null>(null);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state: any) => state.auth.token);
const language = useSelector((state:any)=>state.auth.language);
  useEffect(() => {
    const loadFile = async () => {
      if (!docId) return;

      setLoading(true);
      try {
        const response = await getDocument(docId, token , "panel");
       

        if (response.success && response.doc) {
          setFile(response.doc);
        } else {
          setFile(null);
        }
      } catch (error) {
       
        setFile(null);
      }
      setLoading(false);
    };

    loadFile();
  }, [docId]);

  return (
    <div className="modal fade" id="single_modal" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{language.vdoc}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body" style={{ maxHeight: "500px", overflowY: "auto" }}>
            {loading && <p>Loading...</p>}
            {!loading && !file && <p>No document found</p>}
            {file && (
              <div className="mt-3">
                <p><strong>{file.fileName}</strong></p>
                {file.mimeType.startsWith("image/") && (
                  <img src={file.fileData} alt={file.fileName} style={{ width: "100%", maxHeight: "700px" }} />
                )}
                {file.mimeType === "application/pdf" && (
                  <iframe src={file.fileData} width="100%" height="500px" title="PDF Viewer" />
                )}
                {!file.mimeType.startsWith("image/") && file.mimeType !== "application/pdf" && (
                  <a href={file.fileData} download={file.fileName} className="text-primary">
                    {language.down} {file.fileName}
                  </a>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer d-flex justify-content-between">
            {file && (
              <a href={file.fileData} download={file.fileName} className="btn btn-success">
                {language.down}
              </a>
            )}
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              {language.close}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleView;
